import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as DocumentTypeService from '@/services/document-type.service';
import { IDocumentType } from '@/domain/document-type.model';

@Options({
  name: 'document-type-new',
  components: {
    Toggle,
  },
})
export default class DocumentTypeNew extends Vue {
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public extensions = ['mp4','mpeg','avi','mkv','jpeg','jpg','png'];
  public row: IDocumentType = {
    description: '',
    extensions_enabled: [],
    enabled: true,
  };

  public goBack() {
    this.$router.push('/document-type');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    if (this.row.extensions_enabled.length == 0) {
      this.errors.extensions_enabled = 'Selecione ao menos um item.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      DocumentTypeService.insert({
        description: this.row.description,
        enabled: this.row.enabled,
        extensions_enabled: this.row.extensions_enabled,
      })
        .then(() => {
          this.$router.push('/document-type');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
